import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { XcLoadingModule } from '../loading/loading.module';
import { HelpInputComponent } from './help-input/help-input.component';
import { XcHelpPresetService } from './help-preset.service';
import { XcHelpShellComponent } from './help-shell/help-shell.component';
import { XcHelpService } from './help.service';

@NgModule({
  declarations: [XcHelpShellComponent, HelpInputComponent],
  imports: [
    CommonModule,
    NzModalModule,
    NzTableModule,
    NzTreeModule,
    TranslateModule,
    FormsModule,
    DragDropModule,
    XcLoadingModule,
  ],
  providers: [
    XcHelpPresetService,
    XcHelpService,
    HelpInputComponent,
  ],
  exports: [HelpInputComponent]
})
export class XcHelp2Module { }
